/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
* Author: 
*/

import type { SVGProps } from "react"

const Settings04 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9998 5.00016C14.0794 5.00016 13.3332 5.74636 13.3332 6.66683C13.3332 7.5873 14.0794 8.3335 14.9998 8.3335C15.9203 8.3335 16.6665 7.5873 16.6665 6.66683C16.6665 5.74635 15.9203 5.00016 14.9998 5.00016ZM11.7715 5.8335C12.1416 4.39581 13.4466 3.3335 14.9998 3.3335C16.8408 3.3335 18.3332 4.82588 18.3332 6.66683C18.3332 8.50778 16.8408 10.0002 14.9998 10.0002C13.4466 10.0002 12.1416 8.93785 11.7715 7.50016L2.49984 7.50016C2.0396 7.50016 1.6665 7.12707 1.6665 6.66683C1.6665 6.20659 2.0396 5.8335 2.49984 5.8335L11.7715 5.8335ZM4.99984 11.6668C4.07936 11.6668 3.33317 12.413 3.33317 13.3335C3.33317 14.254 4.07936 15.0002 4.99984 15.0002C5.92031 15.0002 6.6665 14.254 6.6665 13.3335C6.6665 12.413 5.92031 11.6668 4.99984 11.6668ZM1.6665 13.3335C1.6665 11.4925 3.15889 10.0002 4.99984 10.0002C6.55304 10.0002 7.85812 11.0625 8.22816 12.5002L17.4998 12.5002C17.9601 12.5002 18.3332 12.8733 18.3332 13.3335C18.3332 13.7937 17.9601 14.1668 17.4998 14.1668L8.22816 14.1668C7.85812 15.6045 6.55304 16.6668 4.99984 16.6668C3.15889 16.6668 1.6665 15.1744 1.6665 13.3335Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export default Settings04
